import React, { useState } from 'react';
import { Tooltip, useMediaQuery } from '@material-ui/core';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { makeStyles, Theme } from '@material-ui/core/styles';
import FiberManualRecordSharpIcon from '@material-ui/icons/FiberManualRecordSharp';

import { COLOR_PRIMARY_1, COLOR_PRIMARY_2 } from 'src/colors';
import { NeighbourhoodDataCard } from 'src/App/HOC/Cards';
import { Chip } from '@mui/material';
import { abbreviateNumber } from 'src/utils/functions';
import { NEIGHBOURHOOD_TOOLTIP_Z_INDEX } from 'src/const';

const useStylesRoot = makeStyles({
  tooltip: {
    padding: 0,
    width: 400,
  },
});

const NeighbourhoodPointer = ({
  lat,
  lng,
  listings,
  currency,
  isUserAllowed,
  multipleMarkersCallLoading,
  user,
  isLoggedIn,
  setLoginModalOpen,
  setShowSearchCreditDeductWarningModal,
  setSubscriptionModalOpen,
  scale,
  neighbourhoodObj,
  neighbourhoodAnalysisKey,
}) => {
  const matches = useMediaQuery('(max-width:550px)');
  const neighbourhoodTooltipWidth = 450;
  const neighbourhoodTooltipHeight = 300;
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);
  const rootClass = useStylesRoot();

  const icon = (
    <Chip
      label={
        neighbourhoodAnalysisKey === 'occupancy'
          ? `${neighbourhoodObj.occupancyRate}%`
          : neighbourhoodAnalysisKey === 'occupancyRateYearly'
          ? `${neighbourhoodObj.occupancyRateYearlyChange}%`
          : abbreviateNumber(neighbourhoodObj.listingCount, false)
      }
      variant={'filled'}
      sx={{
        minWidth: 50,
        borderColor: 'white',
        borderWidth: '1px',
        transform: `translate(-50%, -50%) scale(${scale})`,
        color: COLOR_PRIMARY_2,
        fontWeight: 500,
        '&.MuiChip-filled': {
          backgroundColor: 'white',
        },
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
      }}
      onMouseLeave={() => {
        setTooltipOpen(false);
      }}
      onClick={() => {
        setTooltipOpen(prev => !prev);
      }}
    />
  );

  return (
    <>
      <ClickAwayListener onClickAway={() => setTooltipOpen(false)}>
        <Tooltip
          interactive
          classes={rootClass}
          open={tooltipOpen}
          onOpen={() => setTooltipOpen(true)}
          onClose={() => {
            !matches && setTooltipOpen(false);
          }}
          style={{ zIndex: NEIGHBOURHOOD_TOOLTIP_Z_INDEX }}
          title={
            <NeighbourhoodDataCard
              listings={listings}
              currency={currency}
              width={neighbourhoodTooltipWidth}
              height={neighbourhoodTooltipHeight}
              isUserAllowed={isUserAllowed}
              multipleMarkersCallLoading={multipleMarkersCallLoading}
              user={user}
              isLoggedIn={isLoggedIn}
              setLoginModalOpen={setLoginModalOpen}
              setShowSearchCreditDeductWarningModal={setShowSearchCreditDeductWarningModal}
              setSubscriptionModalOpen={setSubscriptionModalOpen}
            />
          }
        >
          {icon}
        </Tooltip>
        
      </ClickAwayListener>
    </>
  );
};

export default React.memo(NeighbourhoodPointer);
